document.addEventListener('turbolinks:load', function () {
  const mapElement = document.getElementById('inspection-location-map');

  if(!mapElement) {
    return;
  }

  const latitude = mapElement.dataset.latitude;
  const longitude = mapElement.dataset.longitude;
  let map;

  const inspectionTab = document.getElementById('inspection-details-pill-tab');

  if (longitude && latitude && inspectionTab.classList.contains('active')) {
    map = L.map('inspection-location-map').setView([0, 0], 10);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
    }).addTo(map);

    map.setView([latitude, longitude], 16); // Center the map on the contractor's location

    // Add a marker for the contractor's location
    L.marker([latitude, longitude])
      .addTo(map)
      .bindPopup('Contractor location')
      .openPopup();
  }

  let inspectionTabObserver = new MutationObserver(function(){
    if(inspectionTab.classList.contains('active')){
      if(!map) {
        setTimeout(
          function() {
            map = L.map('inspection-location-map').setView([0, 0], 10);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '© OpenStreetMap contributors',
            }).addTo(map);

            map.setView([latitude, longitude], 16); // Center the map on the contractor's location

            // Add a marker for the contractor's location
            L.marker([latitude, longitude])
              .addTo(map)
              .bindPopup('Contractor location')
              .openPopup();
          },
          500
        )
      }
    }
  });
  inspectionTabObserver.observe(inspectionTab, { attributes: true });
});